import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { RecipientMultiselectDropdownComponent } from './recipient-multiselect-dropdown.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [RecipientMultiselectDropdownComponent],
  exports: [RecipientMultiselectDropdownComponent]
})
export class RecipientMultiselectDropdownModule { }
